import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import zeplinColor from 'theme/Color';

const Card = ({ val, loading }: { val: any; loading: boolean }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        gap: '16px',
        flexDirection: 'column',
        padding: '16px',
      }}
    >
      {loading ? (
        <Skeleton
          variant='rounded'
          width={'100%'}
          height={48}
          sx={{ backgroundColor: zeplinColor.Neutral4 }}
        />
      ) : val?.imageUrl ? (
        <Box
          sx={{
            borderRadius: '8px',
            height: '140px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: zeplinColor.Neutral3,
          }}
        >
          <img
            src={'/assets/no-news.svg'}
            width='40px'
            height='40px'
            alt='zoominfo-no-news'
            style={{ objectFit: 'contain' }}
          />
        </Box>
      ) : (
        <img
          src={val?.imageUrl}
          width='100%'
          height='140px'
          alt='zoominfo-news'
          style={{ objectFit: 'cover' }}
        />
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {val?.categories?.map((item: any) => (
          <Chip
            label={
              <Typography
                variant='responsiveLabel1'
                sx={{ display: 'flex', alignItems: 'center' }}
                color={zeplinColor.Neutral1}
              >
                {item}
              </Typography>
            }
            sx={{
              backgroundColor: zeplinColor.Neutral10,
              color: zeplinColor.Neutral1,
              '&.MuiChip-root': {
                height: '24px',
                padding: '5px 12px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          />
        ))}
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '5rem',
              backgroundColor: zeplinColor.Neutral4,
            }}
          />
        ) : (
          <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
            {dayjs(val?.pageDate).format('DD MMM, YYYY')}
          </Typography>
        )}
      </Box>
      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            width: '5rem',
            backgroundColor: zeplinColor.Neutral4,
          }}
        />
      ) : (
        <Typography
          sx={{
            fontWeight: 510,
            fontSize: '14px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            //   maxWidth: '17rem',
          }}
        >
          {val?.title}
        </Typography>
      )}
      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            width: '5rem',
            backgroundColor: zeplinColor.Neutral4,
          }}
        />
      ) : (
        <Typography
          variant='responsiveBody3'
          color={zeplinColor.Neutral8}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {val?.description}
        </Typography>
      )}
      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            width: '5rem',
            backgroundColor: zeplinColor.Neutral4,
          }}
        />
      ) : (
        <Typography
          variant='responsiveButtonSmall'
          color={zeplinColor.Brand1}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {val?.url}
        </Typography>
      )}
    </Box>
  );
};

export default Card;
